import Vue from 'vue';
import { keyBy } from 'lodash';

import * as types from './mutation-types';

const mutations = {
  [types.SET_PAGES](state, { cardId, pages }) {
    if (pages) {
      const page = pages;
      page.loaded_at = new Date();
      Vue.set(state.pages, page.position, page);
      if (!state.cardPages[cardId]) {
        Vue.set(state.cardPages, cardId, {});
      }
      Vue.set(state.cardPages[cardId], page.position, page);
    }
  },

  [types.SET_PAGE_LIST](state, { cardId, pageList }) {
    const pagesByPosition = keyBy(pageList, 'position');

    Vue.set(state, 'pages', pagesByPosition);

    if (!state.cardPages[cardId]) {
      Vue.set(state.cardPages, cardId, {});
    }

    Vue.set(state.cardPages, cardId, pagesByPosition);
  },

  [types.SET_WRONG_PAGE_LIST](state, wrongPageList) {
    Vue.set(state, 'wrongPages', wrongPageList);
  },

  [types.RESET_WRONG_PAGE_LIST](state) {
    Vue.set(state, 'wrongPages', {});
  },

  [types.SET_PAGINATION](state, pagination) {
    Vue.set(state, 'pagination', pagination);
  },

  [types.SET_QUIZ_VALUE](state, { quiz, value }) {
    Vue.set(state, 'enteredValue', value);
    Vue.set(state.preEnteredValues, quiz.id, value);
  },

  [types.RESET_ENTERED_VALUE](state) {
    Vue.set(state, 'enteredValue', '');
  },

  [types.SET_QUIZ_OPTION](state, { quiz, option }) {
    Vue.set(state, 'selectedOptions', option);
    Vue.set(state.preselectedOption, quiz.id, option);
  },

  [types.RESET_SELECT_OPTIONS](state) {
    Vue.set(state, 'selectedOptions', {});
  },

  [types.RESET_QUIZ_START_TIME](state) {
    Vue.set(state, 'startTime', new Date());
  },

};

export default mutations;
